module.exports = __webpack_public_path__ + "static/media/tiktok-icon.a4fa265e.svg";